<template>

<div v-if="allowed">
<!-- PayPal Logo --><table border="0" cellpadding="10" cellspacing="0" align="center"><tr><td align="center"></td></tr><tr><td align="center"><a href="https://www.paypal.com/eg/webapps/mpp/paypal-popup" title="How PayPal Works" onclick="javascript:window.open('https://www.paypal.com/eg/webapps/mpp/paypal-popup','WIPaypal','toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=1060, height=700'); return false;"><img src="https://www.paypalobjects.com/webstatic/mktg/Logo/pp-logo-200px.png" border="0" alt="PayPal Logo"></a></td></tr></table><!-- PayPal Logo -->
<br>
Please send the payment to <b>paypal@unlocklounge.com</b> and paste the transaction id below
<br>
*Gift or mass <b>ONLY</b>!
<div class="paymentdiv">


<input v-model="txnid" v-on:input="txnidLength" placeholder="Please enter transaction id">
<br>
<v-btn :disabled="!showSubmitButton" @click.native="submitPayment" color="info">Process Payment</v-btn>
<br>
<span v-html="serverResponse"></span>

       </div>
</div>

<div v-else="allowed">
Please contact your reseller to add credits
</div>

</template>
<script>
/* global Store */
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { mapState, dispatch } from 'vuex'
import api from "@/utils/backend-api";
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

  export default {
    components: {
      ConfirmDialog,
    },
    data () {
      return {
        txnid: "",
        serverResponse: "",
        showSubmitButton: false,
        allowed: false
      }
    },
    computed: {},
    mounted () {
    api.getData("processPaypal.php?action=check").then(
      res => {
        if (res.data === "oK"){
          this.allowed = true;
        }
      }
    );
    },
    methods: {
    submitPayment: function(){
    this.serverResponse = "";
    api.postData("processPaypal.php", "txnid=" + this.txnid).then(
      res => {
      this.serverResponse = res.data;
      this.txnid = "";
      this.showSubmitButton = false;
      this.updateCredits();
      },
      err => {
      if (err.message.includes("403"))
        {
          this.$router.push('/login')
        }
        else {
        alert(err.response.data);
        }
      }
    );
    },
    txnidLength: function(){
      if (this.txnid.length > 15){
        this.showSubmitButton = true;
      }
      else {
      this.showSubmitButton = false;
      }
    },
    updateCredits: function(){
      api.getData("userinfo.php").then(res => {
         if (res.data){
           const user = res.data.user;
           const token = localStorage.token;
           Store.dispatch('user/updateUser', {user, token});
         }
         });
    },
    }
  }
</script>
<style>
.paymentdiv{
position: fixed;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
}
</style>



// WEBPACK FOOTER //
// AddCredits.vue?5493b964